import React from 'react'

const WaveBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"></div>
      
      {/* Animated waves */}
      <div className="absolute bottom-0 left-0 right-0 h-20 overflow-hidden">
        <div 
          className="absolute w-[200%] h-20 bg-wave-pattern animate-wave opacity-20"
          style={{
            background: 'linear-gradient(90deg, transparent 0%, rgba(56, 189, 248, 0.1) 25%, rgba(59, 130, 246, 0.2) 50%, rgba(147, 51, 234, 0.1) 75%, transparent 100%)'
          }}
        ></div>
      </div>
      
      {/* Floating particles */}
      <div className="absolute inset-0">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              width: `${Math.random() * 4 + 1}px`,
              height: `${Math.random() * 4 + 1}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 6}s`,
              animationDuration: `${6 + Math.random() * 6}s`
            }}
          ></div>
        ))}
      </div>
      
      {/* Glass morphism overlay */}
      <div className="absolute inset-0 bg-white/5 backdrop-blur-3xl"></div>
    </div>
  )
}

export default WaveBackground